import Format from "../components/format/Format";
import { ButtonValues } from "../types/button.type";

export default function Xml() {
    const buttons: ButtonValues[] = [
        {
            api: '/api/xml/pretty-print',
            buttonLabel: 'Format',
            outputLabel: 'XML',
        },
        {
            api: '/api/xml/is-valid',
            buttonLabel: 'Validate',
            outputLabel: 'Valid',
        },
        {
            api: '/api/xml/json',
            buttonLabel: 'To JSON',
            outputLabel: 'JSON',
        },
        {
            api: '/api/xml/yaml',
            buttonLabel: 'To YAML',
            outputLabel: 'YAML',
        },
    ];

    return (
        <Format inputLabel='XML' buttons={buttons} />
    );
}